import authenticationService from '@/services/authenticationService.js';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
    ? { status: { logged: true, logging: false }, user: user, error: null }
    : { status: { logged: false, logging: false }, user: null, error: null };

export const authentication = {
    namespaced: true,
    state: initialState,
    actions: {
        login({ dispatch, commit }, { usuario, contrasena, dominio, host }) {
            commit('loginRequest', { usuario });
            var that = this;

            authenticationService.login(usuario, contrasena, dominio, host).then(res => {
                if (!!res && (!!res.userId || !!res.userMustChangePassword)) {
                    var user =
                    {
                        userId: res.userId,
                        employeeId: res.employeeId,
                        userMustChangePassword: res.userMustChangePassword,
                        customerId: res.customerId,
                        customerName: res.customerName,
                        licenseExpiryDatetime: res.licenseExpiryDatetime,
                        token: res.token,
                        username: res.username,
                        displayName: res.displayName,
                        email: res.email,
                        domain: res.domain,
                        initials: res.initials,
                        isAdmin: res.isAdmin

                    }
                    //si no vienen las iniciales
                    if (!!user.initials) {
                        //calculamos las iniciales del usuario
                        var names = user.displayName.replace('  ', ' ').split(' ');
                        if (names.length > 1) {
                            user.initials = names[0].substring(0, 1).toUpperCase() + names[1].substring(0, 1).toUpperCase();
                        } else {
                            user.initials = names[0].substring(0, 1).toUpperCase();
                        }
                    }
                    commit('loginSuccess', user);

                } else {
                    commit('loginFailure', 'Usuario/Contraseña incorrectos');
                }
            }).catch(err => {
                if (!!err && !!err.response && !!err.response.status) {
                    switch (err.response.status) {
                        case 409: //no existe empleado para ese usuario
                            commit('loginFailure', 'Su usuario no tiene acceso a esta aplicación.');
                            break;
                        case 404:
                            commit('loginFailure', 'Usuario/Contraseña incorrectos');
                            break;
                        default:
                            commit('loginFailure', 'Usuario/Contraseña incorrectos');
                            break;
                    }
                }
            });

        },
        logout({ commit }) {
            authenticationService.logout().then(res => {
                commit('logout');
            }).catch(err => {
                commit('logout');
            });;
        },
        passwordChanged({ commit }) {
            commit('passwordChangedSuccess');
        }
    },
    mutations: {
        loginRequest(state, user) {
            state.status = { logged: false, logging: true, error: null };
        },
        loginSuccess(state, user) {
            state.status = { logged: true, logging: false, error: null };
            state.user = user;
            localStorage.setItem('user', JSON.stringify(user));
        },
        loginFailure(state, error) {
            state.status = { logged: false, logging: false, error: error };
        },
        logout(state) {
            state.status = { logged: false, logging: false, error: null };
            state.user = null;
            localStorage.removeItem('user');
        },
        passwordChangedSuccess(state) {
            state.user.userMustChangePassword = false;
        },
    }
}
